import React from 'react';
import { RolesUser } from 'shared/enums';
import { TItemsTab } from 'shared/types/types';
import { Link } from 'react-router-dom';
import { useAppSelector } from 'app/store';
import { viewerModel } from 'entities/viewer';
import { uiModel } from 'entities/ui';
import { configTabs } from 'shared/helpers/utils';
import { Button, Tabs } from 'antd';
import { useTabsNavigate } from 'shared/hooks';
import PollPublicated from './pollPublicated/PollPublicated';
import PollArchive from './pollArchive/PollArchive';
import PollUnublicated from './pollUnpublicated/PollUnpublicated';
import style from './index.module.scss';

const allRoles = [
  RolesUser.HRDirector,
  RolesUser.Consultant,
  RolesUser.Employee,
  RolesUser.FirstLine,
  RolesUser.SecondLine,
];

const itemsTab: TItemsTab = [
  {
    label: 'Опубликованное',
    key: 'publicated',
    children: <PollPublicated />,
    role: allRoles,
  },
  {
    label: 'Неопубликованное',
    key: 'unpublicated',
    children: <PollUnublicated />,
    role: allRoles,
  },
  {
    label: 'Архив',
    key: 'archive',
    children: <PollArchive />,
    role: allRoles,
  },
];
const Poll = () => {
  const [activeTab, handler] = useTabsNavigate('poll', itemsTab[0].key);
  const { role } = useAppSelector(viewerModel.me.selectors.selectViewerProfile);
  const tab = useAppSelector(uiModel.Tabs.selectors.selectTabs);
  const tabPane = configTabs(role, itemsTab);

  const setInitialTab = (tab: string) => {
    const exist = itemsTab.every(elem => elem.key !== tab);
    if (!exist) {
      return tab;
    }
    return 'publicated';
  };

  return (
    <>
      <div className={style.actions}>
        <h3>Опросы</h3>
        <Link to={'/polls/create'}>
          <Button type="primary">+ Добавить опрос</Button>
        </Link>
      </div>

      <div className={style.wrap}>
        {/* To do: задать роли! */}
        {role && (
          <Tabs activeKey={setInitialTab(activeTab)} onChange={handler} destroyInactiveTabPane items={tabPane}></Tabs>
        )}
      </div>
    </>
  );
};

export default Poll;
